import { render, staticRenderFns } from "./Earnings-withholding.vue?vue&type=template&id=543678a5&scoped=true"
import script from "./Earnings-withholding.vue?vue&type=script&lang=js"
export * from "./Earnings-withholding.vue?vue&type=script&lang=js"
import style0 from "./Earnings-withholding.vue?vue&type=style&index=0&id=543678a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543678a5",
  null
  
)

export default component.exports